import { gql } from '@apollo/client';

export const ADD_TRANSACTION = gql`
  mutation AddTransaction(
    $portfolioId: ID!
    $tokenId: ID!
    $transactionType: TransactionType!
    $price: String!
    $quantity: String!
    $timestamp: String!
    $fees: String
    $feeQuantity: String
    $notes: String
    $currency: String
    $locationId: ID
    $sourceLocationId: ID
    $destinationLocationId: ID
  ) {
    addTransaction(
      portfolioId: $portfolioId
      tokenId: $tokenId
      transactionType: $transactionType
      price: $price
      quantity: $quantity
      timestamp: $timestamp
      fees: $fees
      feeQuantity: $feeQuantity
      notes: $notes
      currency: $currency
      locationId: $locationId
      sourceLocationId: $sourceLocationId
      destinationLocationId: $destinationLocationId
    ) {
      success
      error
      transaction {
        id
        transactionType
        price
        quantity
        timestamp
        fees
        feeQuantity
        cost
        proceeds
        notes
        currency
        locationId
        sourceLocationId
        destinationLocationId
      }
    }
  }
`;

export const EDIT_TRANSACTION = gql`
  mutation EditTransaction(
    $transactionId: ID!
    $portfolioId: ID!
    $tokenId: ID
    $price: String
    $quantity: String
    $timestamp: String
    $fees: String
    $feeQuantity: String
    $notes: String
    $transactionType: TransactionType
    $currency: String
    $locationId: ID
    $sourceLocationId: ID
    $destinationLocationId: ID
  ) {
    editTransaction(
      transactionId: $transactionId
      portfolioId: $portfolioId
      tokenId: $tokenId
      price: $price
      quantity: $quantity
      timestamp: $timestamp
      fees: $fees
      feeQuantity: $feeQuantity
      notes: $notes
      transactionType: $transactionType
      currency: $currency
      locationId: $locationId
      sourceLocationId: $sourceLocationId
      destinationLocationId: $destinationLocationId
    ) {
      success
      error
      transaction {
        id
        transactionType
        price
        quantity
        timestamp
        fees
        feeQuantity
        cost
        proceeds
        notes
        currency
        locationId
        sourceLocationId
        destinationLocationId
      }
    }
  }
`;

export const MOVE_TRANSACTIONS = gql`
  mutation MoveTransactions(
    $portfolioId: ID!
    $transactionIds: [ID!]!
    $targetTokenId: ID!
  ) {
    moveTransactions(
      portfolioId: $portfolioId
      transactionIds: $transactionIds
      targetTokenId: $targetTokenId
    ) {
      success
      error
      movedCount
      sourceTokenIds
      targetTokenId
      violations {
        tokenId
        tokenTicker
        side
        transactionId
        timestamp
        holdingsAtTimestamp
        requiredQuantity
        shortfall
        message
      }
    }
  }
`;

export const SET_TRANSACTION_HIDDEN = gql`
  mutation SetTransactionHidden($transactionId: ID!, $portfolioId: ID!, $hidden: Boolean!) {
    setTransactionHidden(transactionId: $transactionId, portfolioId: $portfolioId, hidden: $hidden) {
      success
      error
      transaction {
        id
        hidden
      }
    }
  }
`;

export const DELETE_TRANSACTION = gql`
  mutation DeleteTransaction($transactionId: ID!, $portfolioId: ID!) {
    deleteTransaction(transactionId: $transactionId, portfolioId: $portfolioId) {
      success
      error
    }
  }
`;

export const START_TRANSACTIONS_EXPORT = gql`
  mutation StartTransactionsExport(
    $portfolioId: ID!
    $filter: PositionFilterInput
    $exportType: TransactionsExportType
    $year: Int
    $includeNotes: Boolean
    $exportCurrency: String
  ) {
    startTransactionsExport(portfolioId: $portfolioId, filter: $filter, exportType: $exportType, year: $year, includeNotes: $includeNotes, exportCurrency: $exportCurrency) {
      success
      error
      job {
        id
        status
        stage
        createdAt
      }
    }
  }
`;